import { pageRepository } from "~/utils/repositories/page"
import { contentRepository } from "~/utils/repositories/content"
import { jobShopRepository } from "~/utils/repositories/jobshop"
import { searchAndFiltersRepository } from "~/utils/repositories/searchAndFilters"
import { typesenseRepository } from "~/utils/repositories/typesense"
import { jobPageTemplateRepository } from "~/utils/repositories/jobPageTemplate"
import { jobRepository } from "~/utils/repositories/job"
import { offerRepository } from "~/utils/repositories/offer"
import { formRepository } from "~/utils/repositories/form"
import { applicationRepository } from "~/utils/repositories/application"
import { seoRepository } from "~/utils/repositories/seo"
import { settingRepository } from "~/utils/repositories/setting"
import { apiFetchOptions } from "~/utils/apiRetry"

/**
 * Provides the api repositories created in ~/utils/repositories as a plugin.
 * The plugin is usable via $api.{repository} when imported from useNuxtApp().
 */
export default defineNuxtPlugin(() => {
  const { app: { baseURL } } = useRuntimeConfig()

  // Add general, additional config to the fetch instance used for the api repositories.
  // A finite timeout plus one short retry keep a transient content-service slowdown
  // or error from propagating straight into the SSR render (JET-2213).
  const api = $fetch.create(apiFetchOptions(baseURL))

  // Add new repositories here
  const repositories = {
    page: pageRepository(api),
    content: contentRepository(api),
    jobShop: jobShopRepository(api),
    searchAndFilters: searchAndFiltersRepository(api),
    typesense: typesenseRepository(api),
    jobPageTemplate: jobPageTemplateRepository(api),
    job: jobRepository(api),
    offer: offerRepository(api),
    form: formRepository(api),
    application: applicationRepository(api),
    seo: seoRepository(api),
    setting: settingRepository(api),
  }

  return {
    provide: {
      api: repositories,
    },
  }
})
